import { useTracking } from '@change-corgi/core-react/tracking';

import { useTopicSitemapPageData } from '#src/app/pages/topicSitemap/pageContext';
import { useQueryParamValue, useUpdateQueryString } from '#src/app/shared/hooks/location';

type InitialLetterFilter = { name: string; selected: boolean };
type Result = ModelHookResult<
	{
		resultsAreFiltered: boolean;
		filters: InitialLetterFilter[];
	},
	{
		updateFilter: (name: string) => void;
		clearFilters: () => void;
	}
>;

export function useInitialLetterFilter(): Result {
	const filterQueryParam = useQueryParamValue('starts_with') || '';
	const updateQueryParams = useUpdateQueryString();
	const trackEvent = useTracking();
	const filters = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));

	const {
		actions: { refreshData },
	} = useTopicSitemapPageData();

	return {
		data: {
			resultsAreFiltered: filterQueryParam.length > 0,
			filters: filters.map((filter) => ({
				name: filter,
				selected: filterQueryParam === filter,
			})),
		},

		actions: {
			updateFilter: (name: string) => {
				void trackEvent('topic_page_trending_petition_filters_click');
				updateQueryParams({ starts_with: name }, { replace: true });
				refreshData();
			},
			clearFilters: () => {
				void trackEvent('topic_page_trending_petition_clear_filters_click');
				updateQueryParams({ starts_with: undefined }, { replace: true });
				refreshData();
			},
		},
	};
}
